export default "__VITE_ASSET__CHMOeESO__"